<template>
  <div>
    <v-card class="ma-3">
      <v-stepper v-model="stepper">
        <v-stepper-header>
          <v-stepper-step :complete="stepper > 1" step="1"
            >Settings</v-stepper-step
          >

          <v-divider></v-divider>

          <v-stepper-step :complete="stepper > 2" step="2"
            >Recipients</v-stepper-step
          >

          <v-divider></v-divider>

          <v-stepper-step step="3">Audio</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step step="4">Confirmation</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-layout row class="mx-0">
              <v-text-field
                class=""
                label="Broadcast Name"
                v-model="callName"
                ref="callName"
                disabled
                style="max-width: 400px"
                :rules="[rules.required]"
              ></v-text-field>

              <!-- <v-checkbox
                                class="mt-3 ml-3"
                                v-model="confirmListing"
                                color="success"
                                label="Confirm Listing"
                                hide-details
                            ></v-checkbox> -->
            </v-layout>
            <v-layout column class="mx-0">
              <v-select
                class="pr-3 mb-1"
                style="max-width: 400px"
                :items="['CALL', 'TEXT', 'EMAIL']"
                label="Broadcast Type"
                ref="broadcastType"
                v-model="broadcastType"
                clearable
                disabled
                @change="broadcastTypeChanged"
              >
              </v-select>
              <v-select
                class="pr-3 mb-1"
                style="max-width: 400px"
                :items="buildingList"
                label="Building Filter"
                multiple
                ref="building"
                v-model="building"
                @change="buildingsChanged"
                clearable
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0">
                    <span>{{ item }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text caption"
                    >(+{{ building.length - 1 }} others)</span
                  >
                </template>
              </v-select>
              <v-select
                class="pr-3 mb-2"
                style="max-width: 400px"
                :items="gradeList"
                label="Grade Filter"
                multiple
                ref="grade"
                v-model="grade"
                @change="gradesChanged"
                clearable
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0">
                    <span>{{ item }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text caption"
                    >(+{{ grade.length - 1 }} others)</span
                  >
                </template>
              </v-select>

              <v-checkbox
                v-model="isDayCamp"
                label="Broadcast For Day Camp"
                hide-details
                color="success"
                class="mt-0 mb-2"
                @change="isDayCampChanged"
              ></v-checkbox>

              <v-text-field
                v-if="isDayCamp"
                v-model="dayCampWeek"
                label="Day Camp Week"
                class="ml-0 mt-2"
                style="max-width: 400px"
                type="number"
                ref="dayCampWeek"
                :rules="[rules.required]"
              ></v-text-field>
            </v-layout>

            <v-card-actions class="pr-0">
              <v-spacer></v-spacer>
              <v-btn color="default" dark @click="close()">
                Cancel
              </v-btn>
              <v-btn
                color="success"
                @click="continueToRecipients"
                :loading="loadingAccounts"
              >
                Continue
              </v-btn>
            </v-card-actions>
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-layout row>
              <v-flex xs4>
                <v-layout row wrap>
                  <div class="font-weight-medium mr-2" v-if="building.length">
                    Building:
                  </div>
                  <div class="mr-3" v-if="building.length">
                    {{ building.join(",") }}
                  </div>
                  <div class="font-weight-medium mr-2" v-if="grade.length">
                    Grade:
                  </div>
                  <div class="mr-3" v-if="grade.length">
                    {{ grade.join(",") }}
                  </div>
                  <div class="font-weight-medium mr-2" v-if="section.length">
                    Section:
                  </div>
                  <div class="mr-3" v-if="section.length">
                    {{ section.join(",") }}
                  </div>
                </v-layout>
              </v-flex>
              <v-flex xs4>
                <v-layout row justify-center class="mb-3">
                  <v-btn
                    small
                    color="success"
                    outline
                    @click="openChooseNumberDialog('studentList')"
                    >Add Families</v-btn
                  >
                  <!-- <v-btn
                                        small
                                        color="success"
                                        outline
                                        @click="
                                            openChooseNumberDialog(
                                                'manualEntry'
                                            )
                                        "
                                        >Manually Add Numbers</v-btn
                                    > -->
                </v-layout>
              </v-flex>
              <v-flex xs4> </v-flex>
            </v-layout>
            <v-layout row class="my-3">
              <div class="font-weight-medium mr-2 mt-2 title">
                Numbers ({{ numbers.length }})
              </div>
              <v-btn
                class="mb-2 mt-0"
                @click="clearNumbers"
                small
                color="success"
                ><v-icon dark left>mdi-close-circle</v-icon>Clear List</v-btn
              >
            </v-layout>
            <v-layout row>
              <!-- <div style="max-width: 40px;">
                            <v-checkbox
                                class="mt-0 pt-0 pr-3"
                                style="max-width: 40px;"
                                v-model="allNumbersSelected"
                                color="success"
                                hide-details
                            ></v-checkbox>
                        </div> -->
              <div class="font-weight-regular" style="width: 35%">
                {{ broadcastType == "EMAIL" ? "Email" : "Number" }}
              </div>
              <div class="font-weight-regular" style="width: 35%">
                Account ID
              </div>
              <div class="font-weight-regular" style="width: 35%">
                Name
              </div>
              <div class="font-weight-regular" style="width: 35%">
                Hebrew Name
              </div>
              <div
                class="font-weight-regular"
                style="width: 15%"
                v-if="broadcastType != 'EMAIL'"
              >
                Phone Type
              </div>
              <div style="min-width: 10%"></div>
              <!-- <v-btn
                                class="mt-0 pt-0"
                                style="width: 10%"
                                flat
                                icon
                                color="success"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn> -->
            </v-layout>
            <v-divider class="mb-2"></v-divider>
            <div>
              <div v-for="(number, index) in numbersToDisplay">
                <v-layout row>
                  <!-- <v-checkbox
                                    class="mt-0 pt-0"
                                    style="max-width: 40px;"
                                    v-model="number.selected"
                                    color="success"
                                    hide-details
                                ></v-checkbox> -->
                  <div style="width: 35%" v-if="broadcastType != 'EMAIL'">
                    {{ number.number | phone }}
                  </div>
                  <div style="width: 35%" v-if="broadcastType == 'EMAIL'">
                    {{ number.emailAddress }}
                  </div>
                  <div style="width: 35%">
                    {{ number.accountID }}
                  </div>
                  <div style="width: 35%">
                    {{ number.name }}
                  </div>
                  <div style="width: 35%">
                    {{ number.nameH }}
                  </div>
                  <div style="width: 15%" v-if="broadcastType != 'EMAIL'">
                    {{ number.phoneType }}
                  </div>
                  <v-btn
                    class="mt-0 pt-0"
                    style="width: 10%"
                    @click.stop="removeDisplayNumber(number)"
                    flat
                    icon
                    color="success"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-layout>
                <v-divider
                  class="mb-2"
                  v-if="index + 1 < numbers.length"
                ></v-divider>
              </div>
            </div>
            <v-layout justify-center class="mt-3 mb-1">
              <v-pagination
                v-model="pagination.page"
                :length="pages"
                :total-visible="5"
                v-on:input="setPagianation"
              ></v-pagination>
            </v-layout>
            <v-card-actions class="pr-0 mt-2">
              <v-spacer></v-spacer>
              <v-btn outline @click="openConfirmCloseDialog">
                Back
              </v-btn>
              <v-btn color="success" @click="continueToAudio()">
                Continue
              </v-btn>
            </v-card-actions>
          </v-stepper-content>
          <v-stepper-content step="3">
            <div v-if="broadcastType == 'CALL'">
              <v-layout row class="mx-2 mb-2">
                <div
                  style="border: 2px solid rgb(76, 175, 80); border-radius: 5px;"
                  class="pa-2 font-weight-regular"
                >
                  Call Menahal Kesher line<span class="ml-1 font-weight-medium"
                    >929-605-0929 #9</span
                  >
                  to record your audio, once done press the
                  <span class="mr-1 font-weight-medium">Reload Library</span
                  >button
                </div>
              </v-layout>
              <v-layout row v-if="audioFile" class="ml-3 mt-3">
                <div class="font-weight-medium mr-3 pt-3">
                  Selected Recording:
                </div>
                <audio controls :src="audioFile"></audio>
              </v-layout>
              <v-layout class="mx-3 mt-3" row>
                <div
                  style=""
                  class="pt-3 text-xs-center font-weight-medium title"
                >
                  Click the recording you want to use
                </div>
                <v-spacer></v-spacer>
                <v-text-field
                  style="max-width: 250px;"
                  label="Search"
                  v-model="audioSearch"
                  hide-details
                  @input="onAudioSearch"
                  clearable
                  class="mx-2 mt-0 pb-1"
                ></v-text-field>
                <v-menu
                  v-model="audioDatePickerMenu"
                  :close-on-content-click="true"
                  offset-y
                  full-width
                  prepend-icon="mdi-calendar"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="audioFromDate"
                      :value="audioFromDate"
                      label="From Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-on="on"
                      class="mx-2 mt-0 pb-1"
                      style="max-width: 200px"
                      hide-details
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="audioFromDate"
                    @change="audioFromDateChanged(audioFromDate)"
                  ></v-date-picker>
                </v-menu>
                <v-btn
                  :disabeld="loadingAudio"
                  small
                  color="success"
                  :loading="uploading"
                  @click="pickFile()"
                  ><v-icon dark left>mdi-cloud-upload</v-icon>Upload</v-btn
                >
                <input
                  type="file"
                  style="display: none"
                  ref="files"
                  accept=".mp3, .wav"
                  @change="onFilePicked($event)"
                />
                <v-btn
                  @click="loadAudioLibrary"
                  :disabeld="loadingAudio"
                  small
                  color="success"
                  ><v-icon dark left>mdi-reload</v-icon>Reload Library</v-btn
                >
              </v-layout>

              <div style="height: 500px; overflow-y: auto;" class="mx-3 mb-2">
                <div class="title" v-if="!audioLibrary.length">
                  No Recordings
                </div>

                <v-layout
                  row
                  class="pa-2 mb-2"
                  v-for="(audio, index) in audioLibrary"
                  @click="selectAudio(audio)"
                  style="cursor: pointer; border: 1px solid #4caf50; border-radius: 4px"
                >
                  <v-checkbox
                    v-model="audio.selected"
                    color="success"
                    class="ml-2 mt-2 pt-2 pr-3"
                    hide-details
                  ></v-checkbox>
                  <div style="width: 20%" class="pt-3 font-weight-regular">
                    {{ audio.date | time }}
                  </div>
                  <v-layout justify-center style="width: 30%">
                    <div v-if="!audio.editing" class="pt-3 font-weight-regular">
                      {{ audio.name }}
                    </div>
                    <v-btn
                      class="my-0 pt-2"
                      v-if="!audio.editing"
                      @click.stop="editAudio(audio)"
                      flat
                      icon
                      color="success"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                    <v-text-field
                      style="width: 30%"
                      class="pr-0 my-0 mr-3"
                      hide-details
                      v-if="audio.editing"
                      label="Name"
                      v-model="audio.name"
                    ></v-text-field>
                    <v-btn
                      class=""
                      v-if="audio.editing"
                      small
                      dark
                      @click.stop="cancelAudioName(audio)"
                      color="default"
                    >
                      Cancel
                    </v-btn>
                    <v-btn
                      class="mr-3"
                      v-if="audio.editing"
                      small
                      @click.stop="saveAudioName(audio)"
                      color="success"
                    >
                      Save
                    </v-btn>
                  </v-layout>

                  <div style="width: 20%" class="pt-3">
                    <span class="font-weight-regular mr-1">From:</span>
                    <span v-if="audio.callerID != 'ADMIN PORTAL'">{{
                      audio.callerID | phone
                    }}</span>
                    <span v-else>{{ audio.callerID }}</span>
                  </div>
                  <div style="width: 10%" class="pt-3">
                    <span v-if="audio.branch" class="font-weight-regular mr-1"
                      >Branch:</span
                    >
                    <span v-if="audio.branch">{{ audio.branch }}</span>
                  </div>
                  <audio controls :src="audio.recordingURL"></audio>
                  <v-btn
                    class="my-0 pt-2"
                    @click.stop="openDeleteAudioDialog(audio)"
                    flat
                    icon
                    color="success"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-layout>
              </div>
              <div class="mx-3 mb-0 font-weight-medium">
                Files ({{ audioLibrary.length }})
              </div>
            </div>
            <div v-if="broadcastType == 'TEXT'">
              <v-textarea
                outline
                rows="9"
                label="Message"
                v-model="message"
                ref="message"
                :rules="[rules.required]"
              ></v-textarea>
            </div>
            <div v-if="broadcastType == 'EMAIL'">
              <v-layout row>
                <div style="width: 70% !important">
                  <v-text-field
                    outline
                    rows="8"
                    label="Subject"
                    v-model="immunizationBroadcastSettings.subject"
                    ref="subject"
                    :rules="[rules.required]"
                  ></v-text-field>
                  <v-textarea
                    outline
                    rows="9"
                    label="Message"
                    v-model="immunizationBroadcastSettings.firstParagraph"
                    ref="message"
                    :rules="[rules.required]"
                  ></v-textarea>
                </div>
                <div class="mb-0 ml-2" style="width: 30% !important">
                  <v-layout row justify-space-between>
                    <div class="pt-2 font-weight-medium">
                      Attachment
                    </div>
                    <v-btn
                      @click="pickFile()"
                      color="success"
                      class="mt-0"
                      small
                      >Upload<v-icon dark right>mdi-cloud-upload</v-icon></v-btn
                    ><input
                      type="file"
                      style="display: none"
                      ref="files"
                      accept=".pdf"
                      @change="onFilePicked($event)"
                    />
                  </v-layout>
                  <div style="height: 246px; overflow-y: auto;" class="mt-0">
                    <pdf
                      v-if="attachmentURL"
                      style="max-height: 246px !important; width: 100%;"
                      :src="attachmentURL"
                    ></pdf>
                  </div>
                </div>
              </v-layout>
            </div>

            <v-card-actions class="pr-0">
              <v-spacer></v-spacer>
              <v-btn outline @click="stepper = 2">
                Back
              </v-btn>
              <v-btn color="success" @click="continueToReview">
                Continue
              </v-btn>
            </v-card-actions>
          </v-stepper-content>
          <v-stepper-content step="4">
            <div style="" class="pt-3 text-xs-center font-weight-medium title">
              Please Review
            </div>
            <v-layout row justify-space-between align-end>
              <div>
                <v-layout row class="px-3 py-2">
                  <div class="font-weight-medium mr-2 width-200">
                    Broadcast Name:
                  </div>
                  <div>
                    {{ callName }}
                  </div>
                </v-layout>
                <v-layout row class="px-3 py-2">
                  <div class="font-weight-medium mr-2 width-200">
                    Broadcast Type:
                  </div>
                  <div>
                    {{ broadcastType }}
                  </div>
                </v-layout>
                <!-- <v-layout
                                    row
                                    class="px-3 py-2"
                                    v-if="isSchedule"
                                >
                                    <div
                                        class="font-weight-medium mr-2 width-200"
                                    >
                                        Broadcast Time:
                                    </div>
                                    <div>
                                        {{ getBroadcastTime() | time }}
                                    </div>
                                </v-layout> -->
                <v-layout row class="px-3 py-2">
                  <div class="font-weight-medium mr-2 width-200">
                    From:
                  </div>
                  <div>
                    {{ fromNumber | phone }}
                  </div>
                </v-layout>
                <div>
                  <v-layout row class="px-3 py-2">
                    <div class="font-weight-medium mr-2 width-200">
                      Total
                    </div>
                    <div>
                      {{ getTotalCalls() }}
                    </div>
                  </v-layout>
                </div>
                <!-- <v-layout
                                    row
                                    class="px-3 py-2"
                                    v-if="broadcastType == 'CALL'"
                                >
                                    <div
                                        class="font-weight-medium mr-2 width-200"
                                    >
                                        Audio:
                                    </div>
                                    <audio
                                        controls
                                        :src="audioFile"
                                        style="width: 323px;"
                                    ></audio>
                                </v-layout> -->
                <v-layout
                  row
                  class="px-3 py-2"
                  v-if="message && broadcastType == 'TEXT'"
                >
                  <div class="font-weight-medium mr-2 width-200">
                    Message:
                  </div>
                  <div style="width: 60%">
                    {{ message }}
                  </div>
                </v-layout>
                <v-layout row class="px-3 time-list">
                  <v-switch
                    color="success"
                    class="mt-2 mr-3 width-180"
                    v-model="isSchedule"
                    label="Schedule For Later"
                  ></v-switch>
                  <v-menu
                    v-model="datePickerMenu"
                    v-if="isSchedule"
                    :close-on-content-click="true"
                    offset-y
                    full-width
                    prepend-icon="mdi-currency-usd"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="broadcastDate"
                        label="Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        class="width-150 mr-2 mt-0"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="broadcastDate"
                      :min="today"
                    ></v-date-picker>
                  </v-menu>
                  <DxDateBox
                    style="height: 45px; max-width: 150px"
                    type="time"
                    v-if="isSchedule"
                    picker-type="list"
                    :interval="15"
                    ref="broadcastTime"
                    v-model="broadcastTime"
                  />
                </v-layout>
              </div>
              <v-layout class="mb-0" row justify-end>
                <!-- <v-text-field
                                    v-model="testNumber"
                                    class="mx-2"
                                    style="max-width: 150px; min-width: 150px;"
                                    label="Test Number"
                                    ref="testNumber"
                                    :rules="[rules.phoneNumber]"
                                ></v-text-field>
                                <v-btn
                                    :disabled="!testNumber"
                                    color="success"
                                    class="mt-3 mb-0"
                                    style="height: 28px;"
                                    small
                                    @click="send(true)"
                                    >Send Test Call
                                </v-btn> -->
              </v-layout>
            </v-layout>
            <v-card-actions class="pr-0 mt-2">
              <v-spacer></v-spacer>
              <v-btn outline @click="stepper = 2">
                Back
              </v-btn>
              <v-btn :loading="sending" color="success" @click="send()">
                Send
              </v-btn>
            </v-card-actions>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>

    <v-dialog v-model="confirmCloseDialog" max-width="400">
      <v-card class="pa-3">
        <v-card-title class="headline pl-0">
          Are you sure?
        </v-card-title>
        <div class="mb-3">This will clear the list of numbers</div>
        <v-card-actions class="mr-0">
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="confirmCloseDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="success" @click="goBackToSettings()">Go Back</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog persistent v-model="chooseNumbersDialog" max-width="1400">
      <v-card class="pa-3">
        <v-flex
          xs12
          class="px-0 pb-0 xs4 pt-0 scroll"
          style="height: 570px; overflow-y: auto;"
          ><div v-if="selectNumberMode == 'studentList'">
            <v-layout row justify-space-between>
              <v-btn small color="success" @click="toggleAllParents">{{
                selectedParents.length ? "Unselect All" : "Select All"
              }}</v-btn>
              <v-text-field
                style="max-width: 300px;"
                v-model="searchParents"
                append-icon="mdi-search"
                label="Search"
                single-line
                clearable
                hide-details
              ></v-text-field>
            </v-layout>
            <v-data-table
              v-model="selectedParents"
              :headers="parentHeaders"
              :items="parents"
              item-key="accountID"
              class="elevation-0"
              :search="searchParents"
              :rows-per-page-items="[9, 15, 20]"
            >
              <!-- <template v-slot:headers="props">
                                <tr>
                                    <th>
                                        <v-checkbox
                                            :input-value="props.all"
                                            :indeterminate="props.indeterminate"
                                            primary
                                            hide-details
                                            @click.stop="toggleAllParents"
                                            color="success"
                                        ></v-checkbox>
                                    </th>
                                    <th
                                        v-for="header in props.headers"
                                        :key="header.text"
                                        class="text-xs-left"
                                    >
                                        {{ header.text }}
                                    </th>
                                </tr>
                            </template> -->
              <template v-slot:items="props">
                <tr
                  :active="props.selected"
                  @click="props.selected = !props.selected"
                >
                  <td>
                    <v-checkbox
                      :input-value="props.selected"
                      color="success"
                      primary
                      hide-details
                    ></v-checkbox>
                  </td>
                  <td>{{ props.item.accountID }}</td>
                  <td>
                    {{ props.item.name }}
                  </td>
                  <td>
                    {{ props.item.hname }}
                  </td>
                  <td>
                    {{ props.item.hebName }}
                  </td>
                  <td>{{ props.item.address1 }}</td>
                  <!-- <td>{{ props.item.immDetails }}</td>
                                    <td>{{ props.item.immDue }}</td> -->
                </tr>
              </template>
              <template v-slot:no-results>
                <v-alert :value="true" color="error" icon="warning">
                  Your search for "{{ searchParents }}" found no results.
                </v-alert>
              </template>
            </v-data-table>
          </div>
          <div v-if="selectNumberMode == 'staffList'">
            <v-layout row justify-end class="mb-4">
              <v-select
                v-model="selectedTeacherTypes"
                label="Teacher Type"
                clearable
                multiple
                :items="teacherTypes"
                hide-details
                @input="onTeacherTypeChanged"
                class="mr-2"
                style="max-width: 250px"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip v-if="index === 0">
                    <span>{{ item }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="grey--text caption"
                    >(+{{ selectedTeacherTypes.length - 1 }} others)</span
                  >
                </template>
              </v-select>
            </v-layout>
            <v-data-table
              v-model="selectedStaff"
              :headers="staffHeaders"
              :items="staff"
              :pagination.sync="staffPagination"
              select-all
              item-key="teacherCode"
              class="elevation-0"
              :rows-per-page-items="[8, 15, 20]"
            >
              <template v-slot:headers="props">
                <tr>
                  <th>
                    <v-checkbox
                      :input-value="props.all"
                      :indeterminate="props.indeterminate"
                      primary
                      hide-details
                      @click.stop="toggleAllStaff"
                      color="success"
                    ></v-checkbox>
                  </th>
                  <th
                    v-for="header in props.headers"
                    :key="header.text"
                    class="text-xs-left"
                  >
                    {{ header.text }}
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <tr
                  :active="props.selected"
                  @click="props.selected = !props.selected"
                >
                  <td>
                    <v-checkbox
                      :input-value="props.selected"
                      color="success"
                      primary
                      hide-details
                    ></v-checkbox>
                  </td>
                  <td>{{ props.item.teacherCode }}</td>
                  <td>
                    {{ props.item.teacherH }}
                  </td>
                  <td>
                    {{ props.item.class }}
                  </td>
                  <td>{{ props.item.section }}</td>
                  <td>{{ props.item.branch }}</td>
                  <td>{{ props.item.alertPhone }}</td>
                  <td>{{ props.item.type }}</td>
                  <td>
                    {{ props.item.busNumber ? props.item.busNumber : "" }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
          <div
            v-if="selectNumberMode == 'manualEntry'"
            class="mt-3"
            style="height: 500px; overflow-y: auto;"
          >
            <v-layout row v-for="(number, index) in manualNumbers">
              <v-text-field
                class="px-1 mr-2"
                label="Number"
                v-model="number.number"
                ref="manualNumber"
                style="max-width: 50%;"
              ></v-text-field>
              <v-btn @click="addNumber" flat icon color="success">
                <v-icon>mdi-plus-circle</v-icon>
              </v-btn>
              <v-btn
                :disabled="index == 0"
                @click="removeNumber(index)"
                flat
                icon
                color="#f55a4e"
              >
                <v-icon>mdi-minus-circle-outline</v-icon>
              </v-btn>
            </v-layout>
          </div>
        </v-flex>
        <!-- <v-layout
                    row
                    class="mt-2"
                    v-if="selectNumberMode == 'studentList'"
                >
                    <v-select
                        class="pl-0 mb-1 mr-3"
                        style="max-width: 200px"
                        :items="getPhoneTypeList()"
                        label="Phone Type"
                        :rules="[rules.required]"
                        ref="broadcastCallPhoneTypes"
                        v-model="phoneTypes"
                    ></v-select>
                </v-layout> -->
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-select
            v-if="selectNumberMode == 'studentList' && broadcastType != 'EMAIL'"
            class="pl-0 mr-3 pt-1 mb-0"
            style="max-width: 200px"
            :items="getPhoneTypeList()"
            label="Phone Type"
            :rules="[rules.required]"
            ref="broadcastCallPhoneTypes"
            v-model="phoneTypes"
            hide-details
            multiple
          ></v-select>
          <!-- <v-spacer></v-spacer> -->
          <v-btn dark color="default" @click="chooseNumbersDialog = false"
            >Cancel</v-btn
          >
          <v-btn color="success" :loading="addingNumbers" @click="addNumbers"
            >Add Numbers</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog persistent v-model="deleteAudioDialog" max-width="400">
      <v-card class="pa-2">
        <v-card-title class="text-warning headline">Are You Sure?</v-card-title>
        <v-card-text class="mb-3 py-0">
          You will now delete {{ audioToDelete.name }} audio file
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" dark @click="deleteAudioDialog = false"
            >Close</v-btn
          >
          <v-btn :loading="deleting" color="success" @click="deleteAudio()"
            >Delete</v-btn
          >
        </v-card-actions>
        <div class="font-weight-light text-xs-center" style="color: #00d3ee">
          {{ processingMessages }}
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import moment from "moment";
import {
  getDomain,
  formatPhoneNumber,
  onlyUnique,
  groupBy,
  toTitleCase,
  toISOLocal,
  firstToLower,
  except,
} from "../../utils/helpers.js";
import DxDateBox from "devextreme-vue/date-box";
import pdf from "vue-pdf";

export default {
  components: {
    DxDateBox,
    pdf,
  },
  data: () => ({
    processing: false,
    stepper: 0,
    numbersToDisplay: [],
    numbers: [],
    callName: "",
    confirmListing: false,
    fromNumber: "19299550923",
    selectNumberMode: "",
    confirmCloseDialog: false,
    chooseNumbersDialog: false,
    addingNumbers: false,

    branchList: [],
    branch: [],
    staffBranch: [],

    gradeList: [],
    staffGradeList: [],
    grade: [],
    staffGrade: [],

    sectionList: [],
    section: [],
    teachers: [],

    buildingList: [],
    building: [],

    manualNumbers: [],

    isDayCamp: false,
    dayCampWeek: "",

    loadingAudio: false,
    audioLibrary: [],
    allAudioLibrary: [],
    audioSearch: "",
    audioFromDate: "",
    audioDatePickerMenu: false,
    audioToDelete: "",
    deleteAudioDialog: false,
    deleting: false,
    selectedAudio: "",
    audioFile: "",
    message: "",
    uploading: false,
    files: [],
    processingMessages: "",
    showParentsTable: false,

    studentListTab: "parents",
    studentCount: 0,
    parentCount: 0,
    numbersCount: "",
    source: "tuition",
    sending: false,
    regID: "",

    isSchedule: false,
    datePickerMenu: false,
    broadcastTime: new Date(),
    broadcastDate: toISOLocal(new Date(moment())).substr(0, 10),
    today: toISOLocal(new Date(moment())).substr(0, 10),

    phoneTypes: ["PHON"],
    testNumber: "",
    broadcastType: "CALL",
    emailSettings: {},
    immunizationBroadcastSettings: {},

    immunizationStatusFilterOptions: [],
    immunizationStatusFilter: "",
    selectedParents: [],
    students: [],
    studentPagination: {
      sortBy: "studentName",
      rowsPerPage: 9,
    },
    parents: [],
    parentPagination: {
      sortBy: "name",
      rowsPerPage: 9,
    },
    staff: [],
    allStaff: [],
    selectedStaff: [],
    selectedTeacherTypes: [],
    teacherTypes: [],
    staffPagination: {
      sortBy: "name",
      rowsPerPage: 8,
    },

    loadingAccounts: false,
    loadingStaff: false,

    phoneType: {
      homePhone: false,
      cellPhone: false,
      motherPhone: false,
    },

    pagination: {
      totalCount: 0,
      rowsPerPage: 13,
      page: 1,
    },

    attachmentURL: "",

    rules: {
      required: (value) => !!value || "Required.",
      maxMessageLength: (value) =>
        !value || value.length < 738 || "Max length is 737",
      phoneNumber: (v) => {
        return (
          !v ||
          ([10, 11].includes(v.replace(/-/g, "").length) &&
            /^\d+$/.test(v.replace(/-/g, ""))) ||
          "Invalid Phone Number"
        );
      },
    },

    studentUrl: "",
    searchParents: "",

    studentHeaders: [
      {
        text: "Student ID",
        value: "studentID",
        align: "left",
      },
      { text: "Name", value: "studentName", align: "left" },
      { text: "Hebrew Name", value: "studentNameH", align: "left" },
      { text: "Section", value: "sectionDescription", align: "left" },
    ],

    parentHeaders: [
      {
        text: "",
        value: "selected",
      },
      {
        text: "Family ID",
        value: "familyID",
      },
      { text: "Name", value: "name" },
      { text: "Hebrew Name", value: "hname" },
      { text: "Student", value: "hebName" },
      { text: "Address", value: "address1" },
      // { text: "Imm", value: "immDetails" },
      // { text: "Upcoming", value: "immUpcoming" },
    ],

    staffHeaders: [
      { text: "Teacher Code", value: "teacherCode" },
      { text: "Teacher", value: "teacherH" },
      { text: "Class", value: "class" },
      { text: "Section", value: "section" },
      { text: "Branch", value: "branch" },
      { text: "Phone", value: "alertPhone" },
      { text: "Type", value: "type" },
    ],

    studentColumns: [
      {
        sortable: false,
        label: "Student ID",
        field: "studentID",
        hidden: false,
      },
      {
        sortable: true,
        label: "Name",
        field: "studentName",
        hidden: false,
      },
      {
        sortable: false,
        label: "Hebrew Name",
        field: "studentNameH",
        hidden: false,
      },
      {
        sortable: false,
        label: "Section",
        field: "sectionDescription",
        hidden: false,
      },
    ],

    parentColumns: [
      {
        sortable: false,
        label: "Family ID",
        field: "familyID",
        link: "Account View",
        hidden: false,
      },
      {
        sortable: true,
        label: "Name",
        field: "name",
        hidden: false,
      },
      {
        sortable: false,
        label: "Hebrew Name",
        field: "hname",
        hidden: false,
      },
      {
        sortable: false,
        label: "Address",
        field: "address1",
        hidden: false,
      },
    ],

    staffUrl: "",

    staffColumns: [
      {
        sortable: false,
        label: "Teacher Code",
        field: "teacherCode",
        hidden: false,
      },
      {
        sortable: false,
        label: "Teacher",
        field: "teacherH",
        hidden: false,
      },
      {
        sortable: true,
        label: "Class",
        field: "class",
        hidden: false,
      },
      {
        sortable: false,
        label: "Section",
        field: "section",
        hidden: false,
      },
      {
        sortable: false,
        label: "Branch",
        field: "branch",
        hidden: false,
      },
      {
        sortable: false,
        label: "Phone",
        field: "alertPhone",
        hidden: false,
      },
      {
        sortable: false,
        label: "Type",
        field: "type",
        hidden: false,
      },
    ],
  }),
  computed: {
    pages() {
      return this.pagination.rowsPerPage
        ? Math.ceil(this.numbers.length / this.pagination.rowsPerPage)
        : 0;
    },
  },
  mounted() {},
  beforeDestroy() {},
  async created() {
    if (this.$route.query.broadcastText) {
      this.broadcastType = "TEXT";
    }

    this.callName = "MeatNotification_" + moment().format("MM_DD_YYYY");

    this.setBroadcastTime();

    await this.loadRegID();
    await this.loadBuildingList();
    await this.loadGradesList();
    await this.loadBranchList(true);
    //await this.loadTeacherList();

    await this.loadAudioLibrary();
    this.setDefaultAudioFile();
    this.addNumber();
    //this.loadEmailSettings();
    //this.loadImmunizationBroadcastSettings();
  },
  methods: {
    close() {
      this.$router.push({
        name: "BroadcastNotifications",
      });
    },
    async loadRegID() {
      this.regID = await this.$http.get("api/allStudents/getRegID");
    },
    async continueToRecipients() {
      const validations = [this.$refs.callName.validate(true)];

      if (this.isDayCamp) {
        validations.push(this.$refs.dayCampWeek.validate(true));
      }

      if (!validations.every(Boolean)) return;

      await this.loadAccounts();
      //await this.loadStaff();

      this.stepper = 2;

      //this.loadStudentsGrid();
    },
    async loadAccounts() {
      this.loadingAccounts = true;

      const url =
        "api/accounts/GetAccountsForBroadcast?building=" +
        (this.building.length ? this.building.join(",") : "") +
        "&grade=" +
        (this.grade.length ? this.grade.join(",") : "") +
        "&dayCampWeek=" +
        (this.isDayCamp ? this.dayCampWeek : "");

      try {
        this.parents = [];
        this.selectedParents = [];

        const response = await this.$http.get(url);

        this.parents = response
          .filter((account) => {
            let matchedAccount = true;

            return matchedAccount;
          })
          .map((account) => {
            account.selected = true;
            account.accountID = account.familyID;

            return account;
          })
          .sort((a, b) => a.accountID - b.accountID);

        this.selectedParents = this.parents;
        this.immunizationStatusFilterOptions = this.parents
          .map((p) => p.immDetails)
          .filter(onlyUnique)
          .sort();

        this.immunizationStatusFilterOptions.unshift("Select All");

        this.immunizationStatusFilter = this.immunizationStatusFilterOptions;

        this.loadingAccounts = false;

        // this.immunizationStatusFilter = this.immunizationStatusFilterOptions.filter(
        //     (o) => {
        //         const filters = this.immunizationBroadcastSettings.immunizationFilter.split(
        //             "|"
        //         );

        //         return filters.some((f) => f.trim() == o);
        //     }
        // );
        // this.immunizationStatusFilterChanged(
        //     this.immunizationStatusFilter
        // );
      } catch (e) {
        this.loadingAccounts = false;
      }
    },
    async loadStaff() {
      this.loadingStaff = true;

      const url =
        "odata/teachersAllPositions?branch=" +
        (this.branch ? this.branch.map(this.getBranchCode).join(",") : "") +
        "&grade=" +
        this.grade.join(",") +
        "&section=" +
        this.getSectionQuery() +
        "&regID=" +
        this.regID;

      try {
        const response = await this.$http.get(url);

        if (
          response.value.some((s) => s.busNumber) &&
          !this.staffHeaders.some((s) => s.value == "busNumber")
        ) {
          this.staffHeaders.push({
            text: "Bus #",
            value: "busNumber",
          });
        }

        this.staff = response.value
          .map((teacher) => {
            teacher.selected = true;

            return teacher;
          })
          .filter((teacher) => {
            const branchList = this.branch.map(this.getBranchCode);

            return branchList.includes(teacher.branch);
          });

        this.allStaff = this.staff;
        this.teacherTypes = this.staff.map((s) => s.type).filter(onlyUnique);
        this.selectedTeacherTypes = this.teacherTypes;

        this.selectedStaff = this.staff;

        this.loadingStaff = false;
      } catch (e) {
        this.loadingStaff = false;
      }
    },
    immunizationStatusFilterChanged(value) {
      if (value.includes("Select All")) {
        value =
          this.immunizationStatusFilter.length ==
          this.immunizationStatusFilterOptions.length
            ? []
            : this.immunizationStatusFilterOptions.filter(
                (g) => g != "Select All"
              );
        this.immunizationStatusFilter = value;
      }

      this.selectedParents = this.parents.filter((s) =>
        value.some((v) => v == s.immDetails)
      );
    },
    onTeacherTypeChanged(value) {
      this.staff = this.allStaff.filter((s) => value.includes(s.type));
    },
    toggleAllParents() {
      if (this.selectedParents.length) this.selectedParents = [];
      else this.selectedParents = this.parents.slice();
    },
    toggleAllStaff() {
      if (this.selectedStaff.length) this.selectedStaff = [];
      else this.selectedStaff = this.staff.slice();
    },
    disableChooseNumberAction(action) {
      return false;
    },
    setBroadcastTime() {
      const broadcastTime = moment().toDate();
      const currentTime = broadcastTime.getTime();
      const updatedTime = new Date(currentTime + 2 * 60 * 60 * 1000);

      updatedTime.setMinutes(0);

      this.broadcastTime = updatedTime;
    },
    broadcastTypeChanged(value) {
      if (value == "TEXT") {
        this.fromNumber = "18775447264";
        this.phoneTypes = this.immunizationBroadcastSettings.messagePhoneTypes.split(
          ","
        );
      } else {
        this.fromNumber = "19299550923";
        this.phoneTypes = this.immunizationBroadcastSettings.callPhoneTypes.split(
          ","
        );
      }
    },
    async loadBranchList(shouldSetBranch = false) {
      let grade = this.grade
        ? this.grade.filter((b) => this.gradeList.includes(b))
        : "";

      grade = grade ? grade.join(",") : "";

      const branches = await this.$http.get(
        "api/students/getBranchListDetails?grades=" + grade
      );

      this.branchList = branches
        .filter((b) => b.branchCode)
        .sort((a, b) => {
          if (a.branchCode < b.branchCode) {
            return -1;
          }
          if (a.branchCode > b.branchCode) {
            return 1;
          }
          return 0;
        })
        .map((b) => b.branchCode + " - " + b.branchDescH);

      const allBranches = this.branchList;

      if (
        this.$store.state.authentication.branch &&
        !this.$store.state.authentication.branch.includes("null")
      ) {
        const list = this.$store.state.authentication.branch
          .split(",")
          .map((b) => {
            const branch = allBranches.find(
              (br) => this.getBranchCode(br) == b
            );

            return branch;
          });

        this.branchList = list;

        if (shouldSetBranch) {
          this.branch = list;
          this.staffBranch = list;
        }
      }
    },
    getBranchCode(branch) {
      return branch.split(" - ")[0];
    },
    branchChanged(value) {
      const branch = value;

      localStorage.setItem("broadcast-call-branch", branch);

      this.loadGradesList();
      this.loadTeacherList();
    },
    disableBranch() {
      return false;

      if (!this.$store.state.authentication.branch) return false;

      return (
        this.$store.state.authentication.branch &&
        !this.$store.state.authentication.branch.includes("null")
      );
    },
    hasUserBranch() {
      return (
        this.$store.state.authentication.branch &&
        !this.$store.state.authentication.branch.includes("null")
      );
    },
    async loadGradesList() {
      let branch = this.branch.length ? this.branch : "";

      branch = branch ? branch.map(this.getBranchCode).join(",") : "";

      if (!branch && this.hasUserBranch()) {
        branch = this.branchList.map(this.getBranchCode).join(",");
      }

      const url = this.isDayCamp
        ? "api/students/getDayCampGradeList?" +
          "building=" +
          (this.building.length ? this.building.join(",") : "")
        : "api/students/getGradeList?branch=" +
          branch +
          "&section=" +
          this.getSectionQuery() +
          "&building=" +
          (this.building.length ? this.building.join(",") : "");

      const grades = await this.$http.get(url);

      this.gradeList = grades.sort();
      this.gradeList.unshift("Select All");

      const allGrades = await this.$http.get(
        "api/students/getGradeList?branch=" + branch
      );

      this.staffGradeList = allGrades.sort();
      this.staffGradeList.unshift("Select All");
    },
    async loadBuildingList() {
      let grade = this.grade.length ? this.grade : "";

      grade = grade ? grade.join(",") : "";

      const url = this.isDayCamp
        ? "api/students/getDayCampBuildingList?grade=" + grade
        : "api/students/getBuildingList?grade=" + grade;

      const buildings = await this.$http.get(url);

      this.buildingList = buildings.sort();
      this.buildingList.unshift("Select All");
    },
    async loadTeacherList() {
      let branch = this.branch.length
        ? this.branch.map(this.getBranchCode).join(",")
        : "";

      if (!branch && this.hasUserBranch()) {
        branch = this.branchList.map(this.getBranchCode).join(",");
      }

      let grade = this.grade
        ? this.grade.filter((b) => this.gradeList.includes(b))
        : "";

      grade = grade ? grade.join(",") : "";

      const teachers = await this.$http.get(
        "api/students/getTeachersList?branches=" + branch + "&grades=" + grade
      );

      this.teachers = teachers.filter((t) => t.regID == this.regID);

      this.sectionList = this.teachers
        .map((s) => "(" + s.class + ") | " + s.section + " - " + s.teacherH)
        .filter(onlyUnique)
        .sort();
      this.sectionList.unshift("Select All");

      this.section = this.section.filter((s) => {
        const grade = s.split(" | ")[0].replace(/\(|\)/g, "");
        const section = s.split(" | ")[1].split(" - ")[0];
        const teacherName = s.split(" | ")[1].split(" - ")[1];

        const teacher = this.teachers.find(
          (t) =>
            t.class == grade &&
            t.section == section &&
            t.teacherH == teacherName
        );

        return teacher;
      });
    },
    sectionChanged(value) {
      if (value.includes("Select All")) {
        value = this.sectionList.filter((g) => g != "Select All");
        this.section = value;
      }

      this.loadBranchList();
      this.loadGradesList();
    },
    getSectionQuery() {
      return this.section
        .map((s) => {
          const grade = s.split(" | ")[0].replace(/\(|\)/g, "");
          const section = s.split(" | ")[1].split(" - ")[0];
          const teacherName = s.split(" | ")[1].split(" - ")[1];

          // const teacher = this.teachers.find(
          //     (t) =>
          //         t.class == grade &&
          //         t.section == section &&
          //         t.teacherH == teacherName
          // );

          // return teacher.teacherCode;
          return section;
        })
        .join(",");
    },
    gradesChanged(value) {
      if (value.includes("Select All")) {
        value = this.gradeList.filter((g) => g != "Select All");
        this.grade = value;
      }

      this.loadBuildingList();
    },
    buildingsChanged(value) {
      if (value.includes("Select All")) {
        value = this.buildingList.filter((g) => g != "Select All");
        this.building = value;
      }

      this.loadGradesList();
    },
    isDayCampChanged(value) {
      this.loadBuildingList();
      this.loadGradesList();
    },
    loadStudentsGrid() {
      if (!this.$refs.grid) return;

      this.studentUrl =
        "students?branch=" +
        (this.branch.length ? this.branch.join(",") : "") +
        "&grade=" +
        this.grade.join(",") +
        "&section=" +
        this.getSectionQuery();

      if (this.$refs.grid) {
        this.$refs.grid.load(this.studentUrl);
      }

      if (this.$refs.parentGrid) {
        this.$refs.parentGrid.load(this.studentUrl);
      }
    },
    getBroadcastTime() {
      if (!this.isSchedule) return moment().format("YYYY-MM-DD HH:mm:ss");

      const time = moment(this.broadcastTime).format("HH:mm");

      const date = moment(this.broadcastDate).toDate();

      return moment(
        new Date(
          date.getFullYear(),
          date.getMonth(),
          date.getDate(),
          time.split(":")[0],
          time.split(":")[1]
        )
      ).format("YYYY-MM-DD HH:mm:ss");
    },
    async onStudentsLoaded(students) {
      this.loadNumberCount();
    },
    async loadNumberCount() {
      const response = await this.$refs.grid.loadAll();

      this.students = response;
      this.studentCount = response.length;

      const group = groupBy(response, "familyID");

      this.parentCount = Object.keys(group).length;

      this.showParentsTable = true;

      const numbersCount = await this.$http.post(
        "api/broadcast/getNumbersCount?",
        Object.keys(group)
      );

      this.numbersCount = numbersCount;
    },
    getNumbersCount(type) {
      return this.numbersCount[type] || 0;
    },
    studentListMapper(students) {
      const group = groupBy(students, "familyID");

      return Object.keys(group).map((key) => {
        const family = group[key];

        return {
          familyID: key,
          name: family[0].name,
          hname: family[0].hname,
          address1: family[0].address1,
        };
      });
    },
    openChooseNumberDialog(mode) {
      this.selectNumberMode = mode;
      this.chooseNumbersDialog = true;
    },
    clearNumbers() {
      this.numbers = [];
      this.numbersToDisplay = [];
      this.manualNumbers = [
        {
          accountID: "",
          number: "",
        },
      ];
    },
    getPhoneTypes() {
      switch (this.phoneTypes) {
        case "Home Only":
          return ["PHON"];
        case "Father Cell":
          return ["CEL"];
        case "Mother Cell":
          return ["MCEL"];
        case "Home/Father Cell":
          return ["PHON", "CEL"];
        case "Home/Mother Cell":
          return ["PHON", "MCEL"];
        case "Home/Father/Mother Cell":
          return ["PHON", "CEL", "MCEL"];
      }
    },
    getPhoneTypeList() {
      return ["PHON"];

      // return this.broadcastType == "TEXT"
      //     ? ["CEL", "MCEL"]
      //     : ["PHON", "CEL", "MCEL"];
      // return [
      //     "Home Only",
      //     "Father Cell",
      //     "Mother Cell",
      //     "Home/Father Cell",
      //     "Home/Mother Cell",
      //     "Home/Father/Mother Cell",
      // ];
    },
    phoneTypeSelected(value) {
      if (this.phoneType.homePhone && !this.phoneTypes.includes("PHON")) {
        this.phoneTypes.push("PHON");
      } else if (!this.phoneType.homePhone) {
        this.phoneTypes = this.phoneTypes.filter((p) => p != "PHON");
      }

      if (this.phoneType.cellPhone && !this.phoneTypes.includes("CEL")) {
        this.phoneTypes.push("CEL");
      } else if (!this.phoneType.cellPhone) {
        this.phoneTypes = this.phoneTypes.filter((p) => p != "CEL");
      }

      if (this.phoneType.motherPhone && !this.phoneTypes.includes("MCEL")) {
        this.phoneTypes.push("MCEL");
      } else if (!this.phoneType.motherPhone) {
        this.phoneTypes = this.phoneTypes.filter((p) => p != "MCEL");
      }
    },
    openConfirmCloseDialog() {
      if (this.numbers.length) {
        this.confirmCloseDialog = true;
      } else {
        this.stepper = 1;
      }
    },
    goBackToSettings() {
      this.confirmCloseDialog = false;
      this.numbers = [];
      this.numbersToDisplay = [];

      this.stepper = 1;
    },
    continueToAudio() {
      if (!this.numbers.length) {
        this.$notify({
          text: "Please add numbers",
          group: "notification",
          type: "error",
        });

        return;
      }

      // if (this.broadcastType == "TEXT") {
      //     this.stepper = 4;

      //     return;
      // }

      this.stepper = 3;
    },
    setPagianation() {
      if (this.getSkip() >= this.numbers.length) return;

      const number = (this.pagination.page - 1) * this.pagination.rowsPerPage;

      this.numbersToDisplay = this.numbers.slice(
        number,
        number + this.pagination.rowsPerPage
      );
    },
    getSkip() {
      const page = this.pagination.page - 1;

      let skip = page * this.pagination.rowsPerPage;

      if (skip >= this.numbers.length) {
        skip = this.numbers.length - this.pagination.rowsPerPage;
      }

      return skip;
    },
    notifyError(text) {
      this.$notify({
        text: text,
        group: "notification",
        type: "error",
      });
    },
    async addNumbers() {
      if (!this.selectedParents.length) {
        console.log(this.selectedParents);

        return this.notifyError("Please select students");
      }

      if (this.broadcastType == "EMAIL") {
        this.addingNumbers = true;

        const accounts = this.selectedParents.filter((a) => a.emailAddress);

        accounts.forEach((a) => {
          if (this.numbers.some((sn) => sn.emailAddress == a.emailAddress))
            return;

          this.numbers.push({
            accountID: a.accountID,
            name: a.name,
            nameH: a.hname,
            number: null,
            emailAddress: a.emailAddress,
            phoneType: null,
            selected: false,
          });
        });
      } else {
        if (!this.phoneTypes.length) {
          return this.notifyError("Please Select a phone type");
        }

        this.addingNumbers = true;

        const response = await this.$http.post("api/broadcast/loadNumbers", {
          accountIDs: this.selectedParents.map((d) => d.accountID),
          source: this.source,
        });

        const phoneTypes = this.phoneTypes;

        const group = groupBy(response.numbers, "accountID");

        const numberList = Object.keys(group)
          .map((key) => {
            const numbers = group[key].filter((n) => n.phoneNum);

            const filteredNumbers = numbers.filter((n) =>
              phoneTypes.includes(n.phoneType)
            );

            if (!this.phoneTypes.includes("PHON")) {
              return filteredNumbers.length
                ? filteredNumbers
                : numbers.filter((n) => n.phoneType == "PHON");
            }

            return filteredNumbers;
          })
          .flat();

        numberList.forEach((n) => {
          const number = n.phoneNum.replaceAll("-", "");

          if (this.numbers.some((sn) => sn.number == number)) return;

          this.numbers.push({
            accountID: n.accountID,
            name: n.name,
            nameH: n.nameH,
            number: number,
            emailAddress: null,
            phoneType: n.phoneType,
            selected: false,
          });
        });
      }

      this.addingNumbers = false;
      this.chooseNumbersDialog = false;
      this.numbersToDisplay = this.numbers.slice(0, 13);
      //this.selectedParents = [];
      this.selectedStaff = [];
    },
    addNumber() {
      this.manualNumbers.push({
        accountID: "",
        number: "",
      });

      this.$forceUpdate();
    },
    removeNumber(index) {
      this.manualNumbers.splice(index, 1);

      this.$forceUpdate();
    },
    removeDisplayNumber(number) {
      const numberIndex = this.numbers.indexOf(number);

      this.numbers.splice(numberIndex, 1);

      this.setPagianation();

      this.$forceUpdate();
    },
    async loadEmailSettings() {
      this.emailSettings = await this.$http.get(
        "api/broadcast/GetImmEmailSettings"
      );
    },
    async loadImmunizationBroadcastSettings() {
      this.immunizationBroadcastSettings = await this.$http.get(
        "api/broadcast/getImmunizationBroadcastSettings"
      );

      this.grade = this.immunizationBroadcastSettings.gradesFilter.split(",");
      this.building = this.immunizationBroadcastSettings.buildingFilter.split(
        ","
      );
      this.message = this.immunizationBroadcastSettings.textMessage;

      this.phoneTypes =
        this.broadcastType == "TEXT"
          ? this.immunizationBroadcastSettings.messagePhoneTypes.split(",")
          : this.immunizationBroadcastSettings.callPhoneTypes.split(",");

      this.attachmentURL = this.immunizationBroadcastSettings.attachment;
    },
    async loadAudioLibrary() {
      this.loadingAudio = true;

      const audioLibrary = await this.$http.get(
        "api/broadcast/getAudioLibrary"
      );

      this.allAudioLibrary = audioLibrary.map((audio) => {
        audio.selected = false;
        audio.editing = false;
        audio.name = audio.name ? audio.name : "Unnamed";

        return audio;
      });

      this.audioLibrary = this.allAudioLibrary;
      this.loadingAudio = false;
    },
    onAudioSearch(value) {
      this.audioLibrary = [];

      if (!value) {
        this.audioLibrary = this.allAudioLibrary;
      } else {
        this.audioLibrary = this.allAudioLibrary.filter((a) =>
          a.name
            ? a.name.toLowerCase().includes(value.trim().toLowerCase())
            : false
        );
      }
    },
    audioFromDateChanged(value) {
      this.audioLibrary = [];

      if (!value) {
        this.audioLibrary = this.allAudioLibrary;
      } else {
        const date = new Date(value + "T00:00:00");

        this.audioLibrary = this.allAudioLibrary.filter((a) => {
          const audioDate = new Date(a.date);
          return audioDate >= date;
        });
      }
    },
    setDefaultAudioFile() {
      const audio = this.audioLibrary.find((a) => a.id == 547);

      audio.selected = true;

      this.selectedAudio = audio;
      this.audioFile = audio.recordingURL;
    },
    editAudio(audio) {
      audio.editing = true;
      audio.originalName = audio.name;
    },
    cancelAudioName(audio) {
      audio.name = audio.originalName;
      audio.editing = false;
    },
    async saveAudioName(audio) {
      audio.editing = false;

      await this.$http.post(
        "api/broadcast/updateAudioName?id=" + audio.id + "&name=" + audio.name
      );

      this.loadAudioLibrary();
    },
    openDeleteAudioDialog(audio) {
      this.audioToDelete = audio;

      this.deleteAudioDialog = true;
    },
    getRoles() {
      return Array.isArray(this.$store.state.authentication.roles)
        ? this.$store.state.authentication.roles
        : this.$store.state.authentication.roles
        ? this.$store.state.authentication.roles.split(",")
        : [];
    },
    allowBroadcastToParents() {
      return !this.getRoles().includes("BroadcastStaffOnly");
    },
    async deleteAudio() {
      this.deleting = true;

      await this.$http.post(
        "api/broadcast/deleteAudio?id=" + this.audioToDelete.id
      );

      this.deleting = false;
      this.deleteAudioDialog = false;

      this.loadAudioLibrary();
    },
    selectAudio(audio) {
      this.audioLibrary
        .filter((a) => a.recordingURL != audio.recordingURL)
        .forEach((a) => (a.selected = false));

      audio.selected = true;

      this.selectedAudio = audio;
      this.audioFile = audio.recordingURL;
    },
    pickFile() {
      this.$refs.files.click();
    },
    async onFilePicked(e) {
      this.uploading = true;

      const files = e.target.files;

      if (!files) return;

      try {
        var formData = new FormData();

        this.files = files;

        formData.append("upload_file", this.files[0]);

        const response = await this.$http.post(
          "api/broadcast/uploadAudioFile?user=" +
            this.$store.state.authentication.user +
            "&branch=" +
            this.$store.state.authentication.branch,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        this.uploading = false;

        this.loadAudioLibrary();
      } catch (e) {
        this.uploading = false;
      }
    },
    continueToReview() {
      if (!this.numbers.length) {
        this.$notify({
          text: "Please add numbers",
          group: "notification",
          type: "error",
        });

        return;
      }

      if (
        this.broadcastType == "EMAIL" &&
        (!this.$refs.subject.validate(true) ||
          !this.$refs.message.validate(true))
      )
        return;

      this.stepper = 4;
    },
    pickFile() {
      this.$refs.files.click();
    },
    async onFilePicked(e) {
      this.uploading = true;

      const files = e.target.files;

      if (!files) return;

      try {
        var formData = new FormData();

        formData.append("upload_file", files[0]);

        const response = await this.$http.post(
          "api/adminPortal/UploadFile?",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        this.attachmentURL = response.url;

        this.uploading = false;
      } catch (e) {
        this.uploading = false;
      }
    },
    getBroadcastSettingData() {
      return {
        textMessage: this.message,
        recording: this.audioFile,
        buildingFilter: this.building.join(","),
        gradesFilter: this.grade.join(","),
        immunizationFilter: this.immunizationStatusFilter.join("|"),
        callPhoneTypes:
          this.broadcastType == "CALL"
            ? this.phoneTypes.join(",")
            : this.immunizationBroadcastSettings.callPhoneTypes,
        messagePhoneTypes:
          this.broadcastType == "TEXT"
            ? this.phoneTypes.join(",")
            : this.immunizationBroadcastSettings.messagePhoneTypes,
        subject: this.immunizationBroadcastSettings.subject,
        firstParagraph: this.immunizationBroadcastSettings.firstParagraph,
        secondParagraph: this.immunizationBroadcastSettings.secondParagraph,
        attachment: this.attachmentURL,
      };
    },
    getTotalCalls() {
      return this.numbers.length;
    },
    broadcastRequest(isTest) {
      let url = "";

      switch (this.broadcastType) {
        case "CALL":
          url =
            "https://broadcast-3t6ck5zrrq-ue.a.run.app/broadcast/broadcastCall";
          break;
        case "TEXT":
          url =
            "https://broadcast-3t6ck5zrrq-ue.a.run.app/broadcast/broadcastMessage";
          break;
        case "EMAIL":
          url =
            "https://broadcast-3t6ck5zrrq-ue.a.run.app/broadcast/broadcastImmEmail";
          break;
      }

      return this.$http.post(url, {
        from:
          this.broadcastType == "EMAIL" ? "tuition@utaw.org" : this.fromNumber,
        broadcastID: this.broadcastID,
        user: this.$store.state.authentication.user,
        types: this.phoneTypes,
        audioFile: this.broadcastType == "CALL" ? this.audioFile : null,
        audioID: this.broadcastType == "CALL" ? this.selectedAudio.id : null,
        text: this.broadcastType == "TEXT" ? this.message : null,
        broadcastName: this.callName,
        confirmListing: this.confirmListing,
        isImmunizationsFollowUp: false,
        isNotification: true,
        notificationType: "MEAT",
        repeat: 2,
        isTest: isTest,
        testNumber: this.testNumber,
        requestID: 0,
        isMenahalBroadcast: false,
        numbers: this.numbers.map((number) => {
          return {
            accountID: number.accountID,
            number: number.number,
            emailAddress: number.emailAddress,
          };
        }),
        branch: this.branch.join(","),
        grade: this.grade.join(","),
        building: this.building.join(","),
        numberSelectionMode: this.selectNumberMode,
        accountsSource: this.source,
        broadcastTime: this.getBroadcastTime(),
        emailSubject: this.emailSettings.subject,
        emailMessage: this.emailSettings.firstParagraph,
        immunizationBroadcastSetting: this.getBroadcastSettingData(),
      });
    },
    async send(isTest = false) {
      try {
        if (isTest) {
          this.broadcastID = await this.broadcastRequest(isTest);
        } else {
          this.sending = true;

          this.broadcastRequest(isTest);
        }

        if (!isTest) {
          this.sending = false;
          this.$router.push({
            name: "BroadcastNotifications",
          });
        } else {
          this.$notify({
            text: "Test call sent",
            group: "notification",
            type: "success",
          });
        }
      } catch (e) {
        this.sending = false;
      }
    },
  },
};
</script>
<style>
.time-list .dx-texteditor.dx-state-focused.dx-editor-outlined {
  border-color: #30a635 !important;
}
.time-list .dx-texteditor.dx-state-hover {
  border-color: #30a635 !important;
}
.selected-tab {
  color: rgb(76, 175, 80) !important;
  border-bottom: 1px solid rgb(76, 175, 80) !important;
}
</style>
